import type { TweenEasing } from "@slot/presentation";

/** One pulse of the panel: up to `scale` × its rest scale and back, on the runner. */
export interface SavedTotalPulseTuning {
  readonly scale: number;
  readonly upSeconds: number;
  readonly upEasing: TweenEasing;
  readonly downSeconds: number;
  readonly downEasing: TweenEasing;
}

/**
 * The Super Bonus saved total's feel (Cocos `features/persistent-multiplier/persistentMultiplierTuning.ts`, and the
 * `enabledFeatureIds` its `createGameRuntime.ts` passes). The value is the server's (`add_feature_multiplier`'s
 * `totalMultiplier`, shown as sent).
 */
export interface SavedTotalTuning {
  /** The sessions that keep a saved total: the Super Bonus. VS Rush shows no panel. */
  readonly featureIds: readonly string[];
  /** After the value, as on the battle's labels ("9" → "9x"). */
  readonly suffix: string;
  /** Each raise of the total. */
  readonly updatePulse: SavedTotalPulseTuning;
  /** The session's last spin collects the total. Cocos left this a placeholder pulse; no other collect visual exists. */
  readonly collectPulse: SavedTotalPulseTuning;
  /** The value's fly into a battle's top label: its time and easing, and its bow above the higher end, in design units. */
  readonly fly: { readonly seconds: number; readonly arc: number; readonly easing: TweenEasing };
}

export const SAVED_TOTAL_TUNING: SavedTotalTuning = {
  featureIds: ["super_bonus_buy"],
  suffix: "x",
  updatePulse: { scale: 1.12, upSeconds: 0.08, upEasing: "quadOut", downSeconds: 0.1, downEasing: "quadIn" },
  collectPulse: { scale: 1.3, upSeconds: 0.12, upEasing: "quadOut", downSeconds: 0.2, downEasing: "backOut" },
  fly: { seconds: 0.5, arc: 80, easing: "quadIn" },
};
